import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { formatDateTime, formatMoney, formatPaymentMethod } from "@/utils/billingFormat";

const BillPaymentsTable = ({ payments = [], currencyCode = "NPR" }) => {
  if (!payments.length) {
    return (
      <div className="rounded-2xl border border-dashed p-6 text-center text-sm text-muted-foreground">
        No payments recorded yet.
      </div>
    );
  }

  return (
    <>
      <div className="hidden overflow-hidden rounded-2xl border bg-background md:block">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Payment method</TableHead>
              <TableHead>Reference number</TableHead>
              <TableHead>Notes</TableHead>
              <TableHead className="text-right">Amount</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {payments.map((payment) => (
              <TableRow key={payment.id || `${payment.paidAtUtc}-${payment.amount}`}>
                <TableCell>{formatDateTime(payment.paidAtUtc)}</TableCell>
                <TableCell>{formatPaymentMethod(payment.paymentMethod)}</TableCell>
                <TableCell>{payment.referenceNumber || "—"}</TableCell>
                <TableCell className="max-w-xs truncate">
                  {payment.isVoided ? `Voided: ${payment.voidReason || "No reason provided"}` : payment.notes || "—"}
                </TableCell>
                <TableCell className={`text-right font-semibold ${payment.isVoided ? "line-through opacity-60" : ""}`}>
                  {formatMoney(payment.amount, currencyCode)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <div className="grid gap-3 md:hidden">
        {payments.map((payment) => (
          <div key={payment.id || `${payment.paidAtUtc}-${payment.amount}`} className="rounded-2xl border bg-background p-4 shadow-sm">
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="font-semibold">{formatPaymentMethod(payment.paymentMethod)}</p>
                <p className="mt-1 text-xs text-muted-foreground">{formatDateTime(payment.paidAtUtc)}</p>
              </div>
              <p className={`text-right font-semibold ${payment.isVoided ? "line-through opacity-60" : ""}`}>
                {formatMoney(payment.amount, currencyCode)}
              </p>
            </div>
            <div className="mt-3 grid gap-2 text-sm">
              <MobilePaymentRow label="Reference number" value={payment.referenceNumber || "—"} />
              <MobilePaymentRow
                label="Notes"
                value={payment.isVoided ? `Voided: ${payment.voidReason || "No reason provided"}` : payment.notes || "—"}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

const MobilePaymentRow = ({ label, value }) => (
  <div className="flex justify-between gap-4">
    <span className="text-muted-foreground">{label}</span>
    <span className="text-right font-medium">{value}</span>
  </div>
);

export default BillPaymentsTable;
